module.exports = __webpack_public_path__ + "img/de-praktijk-3.dec9e447.jpg";